import { render, staticRenderFns } from "./Cams.vue?vue&type=template&id=4fc189c4&"
import script from "./Cams.vue?vue&type=script&lang=js&"
export * from "./Cams.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Cams.vue"
export default component.exports